import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../../../router/backendComponents/admin/all_routes";
import { isAuthenticated } from "../../../../authentication/backendModule/admin/auth";
import apiRequestCall from "../../../../apiHelper/globalHelper";
import Export from "../../../../formHelper/export";
import Search from "../../../../formHelper/search";
import Pagination from "../../../../formHelper/pagination";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Success from "../../../../formHelper/success";
import Delete from "../../../../formHelper/delete";
import exportApiCall from "../../../../apiHelper/export";
import FilterDropdown from "../../../../formHelper/filterDropDown";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import Table from "../../../../formHelper/list";
import Loader from "../../../../formHelper/Loader";
import Reason from "./reason";
import { parseValidationErrors } from "../../../../apiHelper/validationHelper";
import QuillEditor from "../../../../formHelper/QuillEditor";
import type { RootState, AppDispatch } from "../../../../core/data/redux/store";
import { useDispatch, useSelector } from "react-redux";
/* ---------- Types ---------- */
type Id = number;
interface Branch {
  id: Id;
  name: string;
}

type EditorState = {
  index: number;
  field: "notes" | "description" | "product_specification" | "Comments";
} | null;

interface Option {
  value: Id;
  label: string;
  [k: string]: any;
}
interface CustomerDD {
  id: Id;
  company_name: string;
  owner_name: string;
  address: string;
  state_id: Id;
  other_state?: any;
  city?: any;
  mobile_no?: any;
  email_id?: any;
  landline_no?: any;
  pin_code?: any;
  customer_name?: any;
  owner?: { id: Id; name: string } | null;
}

interface Permission {
  id: number;
  role_id: number;
  name: string;
  role: {
    permissions: Record<string, Record<string, string>>;
  };
}
interface ProductRow {
  [k: string]: any;
}
type FormError = {
  product_list?: { [index: number]: { [field: string]: string | undefined } };
} & { [key: string]: string | undefined };

const DEFAULT_PAYMENT_TERMS = `<ol style="padding-left: 20px;">
  <li style="margin-bottom: 8px;">Quotation is Valid for 30 days.</li>
  <li style="margin-bottom: 8px;">Payment Terms: Advance Against Proforma Invoice.</li>
  <li style="margin-bottom: 8px;">
    Any Government / Local Body Levies, taxes, Cess, Duties, Octroi 
    will be extra <strong>"At Actuals"</strong>.
  </li>
  <li style="margin-bottom: 8px;">
    The Delivery Schedule mentioned against each item is as per the 
    Quotation Date and is subject to prior sales.
  </li>
  <li style="margin-bottom: 8px;">
    <strong>Loading/Unloading:</strong> Material unloading on site will be in your scope.
  </li>
</ol>`;

/* ---------- Helpers ---------- */
const makeOptions = (
  list: Branch[] | CustomerDD[],
  labelKey = "name",
  extra: (i: any) => any = () => ({}),
) =>
  (list as any[]).map((b: any) => ({
    value: b.id,
    label: b[labelKey],
    ...extra(b),
  }));

const selectedOption = (opts: { value: any; label: string }[], id?: any) =>
  !id ? null : opts.find((o) => o.value === id) || null;

const numberOrZero = (v: any) => {
  const n = parseFloat(String(v));
  return Number.isFinite(n) ? n : 0;
};

const Order: React.FC = () => {
  const backendRoute = all_routes.backend;

  /* ---------- State ---------- */
  const [list, setList] = useState<any[]>([]);
  const [formData, setFormData] = useState<any>({
    product_specification: DEFAULT_PAYMENT_TERMS,
    payment_term_condition: DEFAULT_PAYMENT_TERMS,
    date: dayjs().format("YYYY-MM-DD"),
    delivery_date_id: "",
    quotation_type_id: null,
    group_id: null,
    company_id: null,
    owner_id: null,
    principal_id: null,
    billing_state_id: null,
    shipping_state_id: null,
    product_description: "",
    enq_ref: "",
    contact_person: "",
    prepard_by: "",
    currency_id: null,
    delevery_date_id: null,
    payment_term_id: null,
    product_id: null,
    principal_type: "",
    billing_address: "",
    billing_state: "",
    billing_city: "",
    billing_pin_code: "",
    billing_mobile: "",
    billing_email: "",
    billing_landline: "",
    shipping_address: "",
    shipping_state: "",
    shipping_city: "",
    shipping_pin_code: "",
    shipping_mobile: "",
    shipping_email: "",
    shipping_landline: "",
    total_amount: 0,
    courier_id: "",
    extra_notes: "",
    unique_order_no: "",
    unique_quotation_no: "",
    customer_order_no: "",
  });
  const [formDataPendingQuotation, setFormDataPendingQuotation] = useState<any>(
    {
      created_at: "",
      reason: "",
      reason_status_id: "",
      unique_quotation_no: "",
      unique_order_no: "",
      total_amount: 0,
      customer_id: "",
      order_type: "",
      reason_text: "",
      order_id: "",
    },
  );
  const [formError, setFormError] = useState<FormError>({});
  const [formErrorPendingQuotation, setFormErrorPendingQuotation] = useState<{
    [k: string]: string;
  }>({});
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<any | null>(null);
  const [showMessageModal, setShowMessageModal] = useState(false);

  const [query, setQuery] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(() => {
    if (typeof window !== "undefined" && window.innerWidth <= 768) {
      return 5;
    }
    return 10;
  });
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );
  const [ownerFilter, setOwnerFilter] = useState<number[]>([]);
  const [branchFilter, setBranchFilter] = useState<number[]>([]);
  const [principalFilter, setPrincipalFilter] = useState<number[]>([]);
  const [currencyFilter, setCurrencyFilter] = useState<number[]>([]);
  const [statusFilter, setStatusFilter] = useState<number[]>([]);

  const [companyList, setCompanyList] = useState<CustomerDD[]>([]);
  const [ownerList, setOwnerList] = useState<Branch[]>([]);
  const [quotationTypeList, setQuotationTypeList] = useState<Branch[]>([]);
  const [notificationList, setNotificationList] = useState<Branch[]>([]);
  const [addressInfo, setAddressInfo] = useState<any>({});
  const [currencyList, setCurrencyList] = useState<Branch[]>([]);
  const [branchList, setBranchList] = useState<Branch[]>([]);
  const [stateList, setStateList] = useState<Branch[]>([]);
  const [paymentAdvanceDate, setPaymentAdvanceDate] = useState<Branch[]>([]);
  const [statusList, setStatusList] = useState<Branch[]>([]);
  const [courierList, setCourierList] = useState<Branch[]>([]);
  const [productRows, setProductRows] = useState<ProductRow[]>([]);
  const [highlightIndex, setHighlightIndex] = useState<number | null>(null);
  const [quotationReason, setQuotationReason] = useState<any | null>(null);
  const [descReason, setDescReason] = useState<any | null>(null);
  const [orderTitle, setOrderTitle] = useState(false);
  const [closeOrderTitle, setCloseOrderTitle] = useState(false);
  const [quotationType, setQuotationType] = useState("CW");
  const [searchText, setSearchText] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);

  const [currencyName, setCurrencyName] = useState("INR");
  const navigate = useNavigate();
  const [pendingSubmitting, setPendingSubmitting] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [activeTooltipRow, setActiveTooltipRow] = useState<number | null>(null);
  const styleTagRef = useRef<HTMLStyleElement | null>(null);
  const [editor, setEditor] = useState<EditorState>(null);
  const fieldRefs = useRef<Record<string, HTMLDivElement | null>>({});
  const [blinkField, setBlinkField] = useState<string | null>(null);
  const [editorValue, setEditorValue] = useState("");
  const openEditor = (index: number, field: any) =>
    setEditor({
      index,
      field: field === "Comments" ? "product_specification" : field,
    });
  const closeEditor = () => setEditor(null);
  interface QuotationRow {
    [k: string]: any;
  }
  /* ---------- Export states ---------- */
  const [exporting, setExporting] = useState(false);
  const [downloading, setDownloading] = useState(false);

  /* ---------- Small helpers ---------- */
  const setField = useCallback((name: string, value: any) => {
    setFormData((prev: any) => ({ ...prev, [name]: value }));
    setFormError((prev) => {
      if (!prev) return prev;
      const u = { ...prev };
      delete (u as any)[name];
      return u;
    });
  }, []);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const setPendingField = useCallback((name: string, value: any) => {
    setFormDataPendingQuotation((prev: any) => ({ ...prev, [name]: value }));
    setFormErrorPendingQuotation((prev) => {
      if (!prev) return prev;
      const u = { ...prev };
      delete (u as any)[name];
      return u;
    });
  }, []);

  /* ---------- Memoized options ---------- */
  const companyOptions = useMemo(
    () =>
      makeOptions(companyList, "company_name", (b: CustomerDD) => ({
        address: b.address,
        owner_name: b.owner_name,
        state_id: b.state_id,
        other_state: b.other_state,
        city: b.city,
        mobile_no: b.mobile_no,
        email_id: b.email_id,
        landline_no: b.landline_no,
        pin_code: b.pin_code,
        customer_name: b.customer_name,
      })),
    [companyList],
  );

  const ownerOptions = useMemo(() => makeOptions(ownerList), [ownerList]);
  const quotationTypeOptions = useMemo(
    () => makeOptions(quotationTypeList),
    [quotationTypeList],
  );
  const notificationOptions = useMemo(
    () => makeOptions(notificationList),
    [notificationList],
  );
  const stateOptions = useMemo(() => makeOptions(stateList), [stateList]);
  const currencyOptions = useMemo(
    () => makeOptions(currencyList),
    [currencyList],
  );
  const paymentAdvanceOptions = useMemo(
    () => makeOptions(paymentAdvanceDate),
    [paymentAdvanceDate],
  );
  const courierOptions = useMemo(() => makeOptions(courierList), [courierList]);
  const statusOptions = useMemo(() => makeOptions(statusList), [statusList]);

  /* ---------- Totals ---------- */
  const subTotal = useMemo(() => {
    return productRows.reduce((sum, r) => sum + numberOrZero(r.total), 0);
  }, [productRows]);

  useEffect(() => {
    setFormData((prev: any) =>
      prev.total_amount === subTotal
        ? prev
        : { ...prev, total_amount: subTotal },
    );
  }, [subTotal]);

  /* ---------- Data fetch: list ---------- */
  const fetchList = useCallback(
    async ({ page = 1, perPage = 10, search = "" }) => {
      setLoading(true);
      if (search) {
        setLoadingSearch(true);
      }
      try {
        const result = await apiRequestCall("post", backendRoute.getOrder, {
          data: {
            page,
            per_page: perPage,
            start_date: startDate || undefined,
            end_date: endDate || undefined,
            search: searchText,
            owner_list: ownerFilter,
            branch_list: branchFilter,
            principal_list: principalFilter,
            currency_list: currencyFilter,
            status_list: statusFilter,
          },
        });
        const res = result?.data?.data;
        if (res) {
          setList(res.data || []);
          setCurrentPage(res.current_page || page);
          setPerPage(res.per_page || perPage);
          setTotalItems(res.total || 0);
        } else {
          setList([]);
        }
      } catch (error) {
        console.error("Failed to fetch orders:", error);
        setList([]);
      } finally {
        setLoading(false);
        setLoadingSearch(false);
      }
    },
    [
      backendRoute.getOrder,
      endDate,
      startDate,
      ownerFilter,
      branchFilter,
      principalFilter,
      currencyFilter,
      statusFilter,
      searchText,
    ],
  );

  /* ---------- Export helpers (polling) ---------- */
  const triggerDownload = (url: string, filename: string, revoke = false) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
      setDownloading(true);
      setTimeout(() => setDownloading(false), 3000);
      setExporting(false);
      return;
    }
  };

  const pollForFile = useCallback((filename: string) => {
    let attempts = 0;
    const maxAttempts = 60; // ~5 minutes
    const interval = setInterval(async () => {
      attempts++;
      try {
        const res = await exportApiCall("get", `/download-export/${filename}`, {
          responseType: "blob",
        });

        if (res) {
          clearInterval(interval);
          setExporting(false);
          setDownloading(true);

          const blob = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          triggerDownload(url, filename, true);

          setTimeout(() => setDownloading(false), 3000);
        }
      } catch (err: any) {
        if (err?.response?.status !== 404) {
          clearInterval(interval);
          setExporting(false);
          setDownloading(false);
          console.error("Export download failed:", err);
          alert("Export failed while downloading.");
        } else if (attempts >= maxAttempts) {
          clearInterval(interval);
          setExporting(false);
          setDownloading(false);
          alert("Export took too long. Please try again later.");
        }
      }
    }, 5000);
  }, []);

  const exportFile = useCallback(async () => {
    try {
      setExporting(true);
      setDownloading(false);

      const result = await apiRequestCall("post", backendRoute.getOrder, {
        data: {
          search: searchText,
          start_date: startDate || undefined,
          end_date: endDate || undefined,
          owner_list: ownerFilter,
          branch_list: branchFilter,
          principal_list: principalFilter,
          currency_list: currencyFilter,
          status_list: statusFilter,
          download: true,
        },
      });

      const filename = result?.data?.data?.file;
      const fileUrl = result?.data?.data?.url;

      if (!filename) {
        setExporting(false);
        alert("Export request failed. Please try again.");
        return;
      }

      // If server returned a direct url (S3/presigned), use it
      if (fileUrl && !window.location.hostname.includes("localhost")) {
        setDownloading(true);
        triggerDownload(fileUrl, filename);
        setTimeout(() => {
          setDownloading(false);
          setExporting(false);
        }, 3000);
        return;
      }

      pollForFile(filename);
    } catch (error) {
      console.error("Export request failed:", error);
      setExporting(false);
      setDownloading(false);
      alert("Export failed. Please try again.");
    }
  }, [
    backendRoute.getOrder,
    startDate,
    endDate,
    ownerFilter,
    branchFilter,
    principalFilter,
    currencyFilter,
    statusFilter,
    searchText,
    pollForFile,
  ]);

  const getCompanyList = useCallback(async () => {
    try {
      const result = await apiRequestCall("post", backendRoute.getCompanyDD);
      const raw = result?.data?.data;
      if (Array.isArray(raw)) {
        setCompanyList(
          raw.map((item: any) => ({
            id: item.id,
            company_name: item.company_name || "",
            owner_name: item?.owner?.name || "",
            address: item.address || "",
            state_id: item.state_id,
            other_state: item?.other_state,
            city: item?.city,
            email_id: item?.email_id,
            pin_code: item?.pin_code,
            mobile_no: item?.mobile_no,
            landline_no: item?.landline_no,
            customer_name: item?.customer_name,
            owner: item.owner || null,
          })),
        );
      } else {
        setCompanyList([]);
      }
    } catch (error) {
      console.error("Failed to fetch companies:", error);
      setCompanyList([]);
    }
  }, [backendRoute.getCompanyDD]);

  const getCurrency = useCallback(async () => {
    try {
      const result = await apiRequestCall("post", backendRoute.getCurrencyDD);
      const raw = result?.data?.data;
      if (raw && typeof raw === "object") {
        setCurrencyList(
          Object.entries(raw).map(([id, name]) => ({
            id: +id,
            name: String(name),
          })),
        );
      } else setCurrencyList([]);
    } catch (error) {
      console.error("Failed to fetch currency:", error);
      setCurrencyList([]);
    }
  }, [backendRoute.getCurrencyDD]);

  const getPaymentAdvanceList = useCallback(async () => {
    try {
      const result = await apiRequestCall(
        "post",
        backendRoute.getPaymentAdvanceDD,
      );
      const raw = result?.data?.data;
      if (raw && typeof raw === "object") {
        setPaymentAdvanceDate(
          Object.entries(raw).map(([id, date_type]) => ({
            id: +id,
            name: String(date_type),
          })),
        );
      } else setPaymentAdvanceDate([]);
    } catch (error) {
      console.error("Failed to fetch payment advance list:", error);
      setPaymentAdvanceDate([]);
    }
  }, [backendRoute.getPaymentAdvanceDD]);

  const getBranch = useCallback(async () => {
    try {
      const result = await apiRequestCall("post", backendRoute.getBranchDD);
      const raw = result?.data?.data;
      if (raw && typeof raw === "object") {
        setBranchList(
          Object.entries(raw).map(([id, name]) => ({
            id: +id,
            name: String(name),
          })),
        );
      } else setBranchList([]);
    } catch (error) {
      console.error("Failed to fetch branch list:", error);
      setBranchList([]);
    }
  }, [backendRoute.getBranchDD]);

  const getCompanyOwner = useCallback(async () => {
    try {
      const result = await apiRequestCall("post", backendRoute.getOwnerDD);
      const raw = result?.data?.data;
      if (raw && typeof raw === "object") {
        setOwnerList(
          Object.entries(raw).map(([id, name]) => ({
            id: +id,
            name: String(name),
          })),
        );
      } else setOwnerList([]);
    } catch (error) {
      console.error("Failed to fetch owner list:", error);
      setOwnerList([]);
    }
  }, [backendRoute.getOwnerDD]);

  const getStateList = useCallback(async () => {
    try {
      const result = await apiRequestCall("post", backendRoute.getStateDD);
      const raw = result?.data?.data;
      if (raw && typeof raw === "object") {
        setStateList(
          Object.entries(raw).map(([id, name]) => ({
            id: +id,
            name: String(name),
          })),
        );
      } else setStateList([]);
    } catch (error) {
      console.error("Failed to fetch state list:", error);
      setStateList([]);
    }
  }, [backendRoute.getStateDD]);

  const getNotificationList = useCallback(async () => {
    try {
      const result = await apiRequestCall(
        "post",
        backendRoute.getNotificationDD,
      );
      const raw = result?.data?.data;
      if (raw && typeof raw === "object") {
        setNotificationList(
          Object.entries(raw).map(([id, name]) => ({
            id: +id,
            name: String(name),
          })),
        );
      } else setNotificationList([]);
    } catch (error) {
      console.error("Failed to fetch notification list:", error);
      setNotificationList([]);
    }
  }, [backendRoute.getNotificationDD]);

  const getQuotationTypeList = useCallback(async () => {
    try {
      const result = await apiRequestCall(
        "post",
        backendRoute.getQuotationTypeDD,
      );
      const raw = result?.data?.data;
      if (raw && typeof raw === "object") {
        setQuotationTypeList(
          Object.entries(raw).map(([id, name]) => ({
            id: +id,
            name: String(name),
          })),
        );
      } else setQuotationTypeList([]);
    } catch (error) {
      console.error("Failed to fetch quotation type list:", error);
      setQuotationTypeList([]);
    }
  }, [backendRoute.getQuotationTypeDD]);

  const getStatusList = useCallback(async () => {
    try {
      const result = await apiRequestCall(
        "post",
        backendRoute.getOrderStatusDD,
      );
      const raw = result?.data?.data;
      if (raw && typeof raw === "object") {
        setStatusList(
          Object.entries(raw).map(([id, name]) => ({
            id: +id,
            name: String(name),
          })),
        );
      } else setStatusList([]);
    } catch (error) {
      console.error("Failed to fetch status list:", error);
      setStatusList([]);
    }
  }, [backendRoute.getOrderStatusDD]);

  const getCourierList = useCallback(async () => {
    try {
      const result = await apiRequestCall("post", backendRoute.getCourierDD);
      const raw = result?.data?.data;
      if (raw && typeof raw === "object") {
        setCourierList(
          Object.entries(raw).map(([id, name]) => ({
            id: +id,
            name: String(name),
          })),
        );
      } else setCourierList([]);
    } catch (error) {
      console.error("Failed to fetch courier list:", error);
      setCourierList([]);
    }
  }, [backendRoute.getCourierDD]);

  /* ---------- Row/product helpers ---------- */
  const deleteProduct = useCallback((index: number) => {
    setProductRows((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      return updated;
    });
  }, []);

  const updateRow = useCallback((index: number, field: string, value: any) => {
    setProductRows((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };

      // recompute numeric fields if present
      // const quantity = numberOrZero(updated[index].quantity);
      // const price = numberOrZero(updated[index].price);
      // const discount = numberOrZero(updated[index].discount);
      // const igstRate = numberOrZero(updated[index].igst);
      // const subtotal = quantity * price;
      // const discountAmount = subtotal * (discount / 100);
      // const discountedTotal = subtotal - discountAmount;
      // const igstAmount = discountedTotal * (igstRate / 100);
      // updated[index].net_price = +discountedTotal.toFixed(2);
      // updated[index].total = +(discountedTotal + igstAmount).toFixed(2);

      return updated;
    });

    setFormError((prev) => {
      if (!prev.product_list?.[index]) return prev;
      const next = { ...prev };
      const rowErrors = { ...next.product_list![index] };
      delete rowErrors[field];
      if (Object.keys(rowErrors).length === 0) {
        const newPL = { ...next.product_list };
        delete (newPL as any)[index];
        if (Object.keys(newPL).length === 0) delete (next as any).product_list;
        else next.product_list = newPL;
      } else {
        next.product_list = { ...next.product_list, [index]: rowErrors };
      }
      return next;
    });
  }, []);

  useEffect(() => {
    if (!closeOrderTitle) return;

    setProductRows((prev) =>
      prev.map((row) =>
        row.send_qty == null || row.send_qty === 0
          ? { ...row, send_qty: numberOrZero(row.quantity) }
          : row,
      ),
    );
  }, [closeOrderTitle]);

  useEffect(() => {
    if (!editor) return;

    const field =
      editor.field === "Comments" ? "product_specification" : editor.field;

    setEditorValue(productRows[editor.index]?.[field] || "");
  }, [editor, productRows]);

  /* ---------- Update / delete / submit ---------- */
  const updateRecord = useCallback(
    (row: any) => {
      setFormError({});

      if (!row) return;

      // avoid mutating the incoming object
      const {
        id,
        order,
        currency_id,
        order_details,
        billing_contact_person,
        date,
        close_order,
        ...rest
      } = row;

      // one-pass lookups and single setFormData call
      if (order) setOrderTitle(true);

      if (close_order) setCloseOrderTitle(true);

      const quotationTypeOptions: Option[] = quotationTypeList.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      const quotationType =
        selectedOption(quotationTypeOptions, row?.quotation_type_id)?.label ??
        "CW";

      const selectedCurrency = currencyList.find((c) => c.id === currency_id);
      setCurrencyName(selectedCurrency?.name ?? "");

      const newFormData = {
        ...rest,
        order_id: id,
        currency_id,
        contact_person: billing_contact_person ?? "",
        date: date ?? "",
        quotation_type: quotationType,
      };
      setSelectedId(id);
      setFormData(newFormData);
      setProductRows(order_details ?? []);
      setShowForm(true);
    },
    [currencyList],
  );

  const deleteRecord = useCallback((row: any) => {
    setDeleteId(row);
    setShowDeleteModal(true);
    setOrderTitle(true);
  }, []);

  const confirmDelete = useCallback(async () => {
    const result = await apiRequestCall("post", backendRoute.deleteOrder, {
      data: {
        id: deleteId?.id,
        unique_quotation_no: deleteId?.unique_quotation_no,
      },
    });

    if (result?.data?.code === 200) {
      fetchList({ page: currentPage, perPage, search: searchText });
      setShowMessage(result?.data?.message);
      setShowSuccess(true);
    }
    setDeleteId(null);
    setShowDeleteModal(false);
  }, [
    backendRoute.deleteOrder,
    backendRoute.deleteQuotation,
    currentPage,
    deleteId,
    fetchList,
    perPage,
  ]);

  const resetForm = useCallback(() => {
    setFormData({
      product_specification: DEFAULT_PAYMENT_TERMS,
      payment_term_condition: DEFAULT_PAYMENT_TERMS,
      product_id: "",
      principal_id: "",
      product_description: "",
      principal_type: "",
      total_amount: 0,
      date: dayjs().format("YYYY-MM-DD"),
      delivery_date_id: "",
      quotation_type_id: null,
      group_id: null,
      company_id: null,
      owner_id: null,
      billing_state_id: null,
      shipping_state_id: null,
      enq_ref: "",
      contact_person: "",
      prepard_by: "",
      currency_id: null,
      delevery_date_id: null,
      payment_term_id: null,
      billing_address: "",
      billing_state: "",
      billing_city: "",
      billing_pin_code: "",
      billing_mobile: "",
      billing_email: "",
      billing_landline: "",
      shipping_address: "",
      shipping_state: "",
      shipping_city: "",
      shipping_pin_code: "",
      shipping_mobile: "",
      shipping_email: "",
      shipping_landline: "",
      overdue_no: "",
      overdues_value: "",
      courier_id: "",
      extra_notes: "",
      unique_order_no: "",
      unique_quotation_no: "",
      customer_order_no: "",
    });

    setOrderTitle(false);
    setFormError({});
    setSelectedId(null);
    setShowForm(false);
    setProductRows([]);
  }, []);

  const parseErrors = useCallback(
    (errors: Record<string, string>): FormError => {
      const result: FormError = {};
      for (const key in errors) {
        if (key.startsWith("product_list.")) {
          const parts = key.split(".");
          const index = Number(parts[1]);
          const field = parts[2];
          if (!isNaN(index) && field) {
            result.product_list ??= {};
            result.product_list[index] ??= {};
            const readableField = field.replace(/_/g, " ");
            result.product_list[index][field] = `${
              readableField.charAt(0).toUpperCase() + readableField.slice(1)
            } field is required.`;
          }
        } else {
          result[key] = errors[key];
        }
      }
      return result;
    },
    [],
  );

  const handleSubmit = useCallback(async () => {
    try {
      const payload = {
        ...formData,
        product_list: productRows,
        update_status: !!selectedId,
        quotation_id: selectedId,
        close_order_status: closeOrderTitle,
      };
      const route = orderTitle
        ? backendRoute.storePartialOrder
        : backendRoute.addUpdateQuotation;
      const result = await apiRequestCall("post", route, { data: payload });

      if (result?.data?.code === 221) {
        setFormError(parseErrors(result?.data?.errors));
        return;
      }

      if (result?.data?.code === 200) {
        resetForm();
        setShowSuccess(true);
        setShowMessage(result?.data?.message);
        navigate("/partial-order");
        setCloseOrderTitle(false);
        setSubmitting(true);
      } else {
        setShowMessage(result?.data?.message || "Operation failed");
      }
    } catch (err) {
      console.error("Failed to submit:", err);
      setShowMessage("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }, [
    backendRoute.addUpdateQuotation,
    backendRoute.storePartialOrder,
    apiRequestCall,
    currentPage,
    fetchList,
    formData,
    orderTitle,
    parseErrors,
    perPage,
    productRows,
    resetForm,
    selectedId,
    setFormError,
    setShowMessage,
    setShowSuccess,
    setSubmitting,
  ]);

  /* ---------- Reason status update ---------- */
  const updateReasonStatus = useCallback(async () => {
    try {
      setPendingSubmitting(true);
      setOrderTitle(true);
      const result = await apiRequestCall("post", backendRoute.addOrderReason, {
        data: {
          order_id: formDataPendingQuotation?.order_id,
          quotation_id: quotationReason?.id,
          order_date: formDataPendingQuotation?.created_at,
          order_number: formDataPendingQuotation?.unique_order_no,
          order_value: formDataPendingQuotation?.total_amount,
          customer_id: formDataPendingQuotation?.customer_id,
          reason_status_id: formDataPendingQuotation?.reason_status_id,
          quotation_status_code: formDataPendingQuotation?.reason,
          unique_quotation_no: formDataPendingQuotation?.unique_quotation_no,
          reason_text: formDataPendingQuotation?.reason_text,
          total_amount: formDataPendingQuotation?.total_amount,
        },
      });

      if (result?.data?.code === 221) {
        setFormErrorPendingQuotation(
          parseValidationErrors(result?.data?.errors),
        );
        return;
      }

      if (result?.data?.code === 200) {
        fetchList({ page: currentPage, perPage, search: searchText });
        setShowMessage(result?.data?.message);
        setShowSuccess(true);
        setShowMessageModal(false);
        setOrderTitle(false);
      } else {
        setShowMessage(result?.data?.message || "Failed to add order reason");
      }
      setDeleteId(null);
      // close modal using existing approach
      (document.getElementById("messageModal") as any)?.click?.();
    } catch (err) {
      console.error("Failed to add order reason:", err);
      setShowMessage("Something went wrong. Please try again.");
    } finally {
      setPendingSubmitting(false);
    }
  }, [
    apiRequestCall,
    backendRoute.addOrderReason,
    formDataPendingQuotation,
    quotationReason,
    currentPage,
    fetchList,
    perPage,
    parseValidationErrors,
    setOrderTitle,
    setFormErrorPendingQuotation,
    setShowMessage,
    setShowSuccess,
    setDeleteId,
    setPendingSubmitting,
  ]);

  const handleRow = useCallback((row: any) => {
    setQuotationReason(row);
    setFormErrorPendingQuotation({});
    const bulletReason =
      row?.pending_quotation_details?.reason
        ?.split(",")
        .map((item: any) => item.trim())
        .filter(Boolean)
        .map((item: any) => `• ${item}`)
        .join("\n") || "";

    setFormDataPendingQuotation({
      order_id: row?.id,
      created_at: row.created_at,
      reason: row?.pending_quotation_details?.reason,
      unique_quotation_no: row.unique_quotation_no,
      unique_order_no: row.unique_order_no,
      total_amount: row.total_amount,
      customer_id: row.customer_id,
      reason_text: "",
      reason_status_id: row?.pending_quotation_details?.reason_status_id || "",
    });
    setDescReason(bulletReason);
    setShowMessageModal(true);
  }, []);

  const searchTextData = (text: string) => {
    setSearchText(text);
  };

  /* ---------- Effects ---------- */
  useEffect(() => {
    getCurrency();
    getCompanyList();
    getCompanyOwner();
    getQuotationTypeList();
    getNotificationList();
    getStateList();
    getBranch();
    getPaymentAdvanceList();
    getStatusList();
    getCourierList();
  }, []);

  useEffect(() => {
    fetchList({ page: currentPage, perPage, search: searchText });
  }, [
    startDate,
    endDate,
    perPage,
    currentPage,
    ownerFilter,
    branchFilter,
    principalFilter,
    currencyFilter,
    statusFilter,
    searchText,
    fetchList,
  ]);

  const handlePdfDownload = async (row: QuotationRow) => {
    try {
      const payload = {
        order_id: row.id,
        unique_order_no: row.unique_order_no,
      };

      const result = await apiRequestCall("post", backendRoute.orderPdfStatus, {
        data: payload,
      });

      if (result?.data?.data?.status === "ready") {
        const path = row.base_pdf_url + "/" + row.pdf_name;
        window.open(path, "_blank");
        return;
      }

      setActiveTooltipRow(row.id);

      setTimeout(() => {
        setActiveTooltipRow(null);
      }, 1000);
    } catch {
      setActiveTooltipRow(row.id);

      setTimeout(() => {
        setActiveTooltipRow(null);
      }, 1000);
    }
  };

  useEffect(() => {
    if (!showForm) return;
    if (!styleTagRef.current) {
      const tag = document.createElement("style");
      tag.innerHTML = `.offcanvas-end.offcanvas-large{width:1600px!important;visibility:visible!important;}`;
      document.head.appendChild(tag);
      styleTagRef.current = tag;
    }
    return () => {
      if (styleTagRef.current) {
        styleTagRef.current.remove();
        styleTagRef.current = null;
      }
    };
  }, [showForm]);

  const setRef = (name: string) => (el: HTMLDivElement | null) => {
    fieldRefs.current[name] = el;
  };

  useEffect(() => {
    const firstErrorKey = Object.keys(formError)[0];

    if (firstErrorKey && fieldRefs.current[firstErrorKey]) {
      const el = fieldRefs.current[firstErrorKey];

      el?.scrollIntoView({ behavior: "smooth", block: "center" });
      setBlinkField(firstErrorKey);

      setTimeout(() => setBlinkField(null), 1000000); // stop blinking
    }
  }, [formError]);

  const permission = useSelector(
    (state: RootState) => state.rolesPermissions?.data,
  ) as Permission | null;

  const permissionMap = useMemo(() => {
    return permission?.role?.permissions ?? {};
  }, [permission]);

  /* ---------- Columns (memoized) ---------- */
  const columns = [
    {
      key: "id",
      label: "Sr",
      render: (_: any, i: number) => (currentPage - 1) * perPage + i + 1,
    },
    { key: "company_details.company_name", label: "Company Name" },
    { key: "unique_order_no", label: "Order No" },
    { key: "customer_order_no", label: "Customer Order" },
    { key: "total_amount", label: "Total" },
    { key: "lead_from", label: "Lead From" },
    { key: "branch_details.name", label: "Branch" },
    {
      key: "created_at",
      label: "Created Date",
      render: (row: any) =>
        row.created_at
          ? dayjs(row.created_at, "DD-MM-YYYY").format("DD/MM/YYYY")
          : "",
    },
    ...(permissionMap?.order?.view_order_reason ||
    permissionMap?.order?.edit_order_reason
      ? [
          {
            key: "reason",
            label: "Reasons",
            render: (row: any) => (
              <div className="hstack gap-2 fs-15">
                {/* VIEW REASON */}
                {permissionMap?.order?.view_order_reason && (
                  <button
                    title="View Reason"
                    type="button"
                    className="btn btn-soft-success btn-sm"
                    onClick={() => handleRow(row)}
                  >
                    <i className="ti ti-file" />
                  </button>
                )}
              </div>
            ),
          },
        ]
      : []),
    ...(permissionMap?.order?.generate_partial_order ||
    permissionMap?.order?.close_order ||
    permissionMap?.order?.download_order
      ? [
          {
            key: "operation",
            label: "Operations",
            render: (row: any) => (
              <div className="hstack gap-2 fs-15 align-items-center">
                {/* GENERATE PARTIAL ORDER */}
                {permissionMap?.order?.generate_partial_order &&
                  row?.is_order_closed == "0" && (
                    <button
                      title="Generate Partial Order"
                      style={{
                        backgroundColor: "rgba(13, 110, 253, 0.15)",
                        color: "#0d6efd",
                        border: "1px solid rgba(13, 110, 253, 0.2)",
                        borderRadius: "6px",
                        padding: "4px 8px",
                      }}
                      onClick={() => {
                        const rec = selectedOption(
                          quotationTypeOptions,
                          row?.quotation_type_id,
                        );
                        setQuotationType(rec?.label || "CW");
                        updateRecord({ ...row, order: true });
                      }}
                    >
                      <i className="feather feather-shopping-cart" />
                    </button>
                  )}

                {/* PARTIAL GENERATED */}
                {permissionMap?.order?.generate_partial_order &&
                  row?.is_order_closed != "0" && (
                    <button
                      title="Partial Order Generated"
                      className="btn btn-icon btn-sm btn-soft-success"
                    >
                      <i className="feather feather-package" />
                    </button>
                  )}

                {/* CLOSE ORDER */}
                {permissionMap?.order?.close_order && (
                  <button
                    disabled={row?.is_order_closed != "0"}
                    title={
                      row?.is_order_closed == "0"
                        ? "Close order ?"
                        : "Partial Order Can Not Close"
                    }
                    className={`btn btn-icon btn-sm ${
                      row?.is_order_closed == "0"
                        ? "btn-soft-primary"
                        : "btn-soft-success"
                    }`}
                    onClick={() => {
                      const rec = selectedOption(
                        quotationTypeOptions,
                        row?.quotation_type_id,
                      );
                      setQuotationType(rec?.label || "CW");
                      updateRecord({
                        ...row,
                        order: true,
                        close_order: true,
                      });
                    }}
                  >
                    {row?.is_order_closed == "0" ? (
                      <i className="feather feather-x" />
                    ) : (
                      <i className="feather feather-check" />
                    )}
                  </button>
                )}

                {/* DOWNLOAD ORDER */}
                {permissionMap?.order?.download_order && (
                  <button
                    className="btn btn-icon btn-sm btn-soft-warning"
                    onClick={() => handlePdfDownload(row)}
                  >
                    <i className="feather feather-download" />
                  </button>
                )}
              </div>
            ),
          },
        ]
      : []),
    ...(permissionMap?.order?.delete_order
      ? [
          {
            key: "action",
            label: "Action",
            render: (row: any) => (
              <div className="hstack gap-2 fs-15">
                <button
                  title="Delete order"
                  className="btn btn-icon btn-sm btn-soft-danger"
                  onClick={() => deleteRecord(row)}
                >
                  <i className="feather-trash" />
                </button>
              </div>
            ),
          },
        ]
      : []),
  ];
  /* ---------- UI disabled date ---------- */
  const disabledDate = (current: dayjs.Dayjs | null) =>
    !!current && current.isAfter(dayjs(), "day");

  const saveEditorValue = () => {
    if (!editor) return;

    const field =
      editor.field === "Comments" ? "product_specification" : editor.field;

    setProductRows((prev) => {
      const updated = [...prev];

      updated[editor.index] = {
        ...updated[editor.index],
        [field]: editorValue,
      };

      return updated;
    });
  };
  const renderMobileProductCards = (): JSX.Element[] =>
    productRows.map((row: any, index: number) => {
      return (
        <div className="card mb-2" key={index} style={{ fontSize: "12px" }}>
          <div className="card-body p-2">
            <div className="d-flex justify-content-between align-items-start mb-2">
              <div>
                <div style={{ fontWeight: 700 }}>{row.part_no ?? "—"}</div>
                <div className="text-muted small">{row.hsn_code ?? ""}</div>
              </div>

              <div className="text-end">
                <div className="small text-muted">Price</div>
                <div style={{ fontWeight: 700 }}>
                  {Number(row.price ?? 0).toFixed(2)} {currencyName}
                </div>
              </div>
            </div>

            <div className="mb-2">
              <textarea
                disabled
                className="form-control form-control-sm"
                value={row.description ?? ""}
                rows={2}
                style={{ resize: "none", fontSize: "12px" }}
              />
            </div>

            <div className="d-flex gap-2 flex-wrap align-items-center mb-2">
              <div className="small text-muted">Qty</div>
              <div>
                <div className="input-group input-group-sm">
                  <button
                    disabled
                    type="button"
                    className="btn btn-sm btn-outline-success"
                  >
                    −
                  </button>
                  <input
                    disabled
                    className="form-control form-control-sm text-center"
                    style={{ maxWidth: "60px", fontSize: "12px" }}
                    value={row.quantity ?? 0}
                  />
                  <button
                    disabled
                    type="button"
                    className="btn btn-sm btn-outline-success"
                  >
                    +
                  </button>
                </div>
              </div>

              <div style={{ minWidth: 110 }}>
                <div className="small text-muted">Send Qty</div>
                <input
                  className="form-control form-control-sm"
                  type="number"
                  min={1}
                  value={closeOrderTitle ? row.quantity : (row.send_qty ?? "0")}
                  placeholder="0"
                  onChange={(e) =>
                    updateRow(index, "send_qty", numberOrZero(e.target.value))
                  }
                  disabled={closeOrderTitle ? true : false}
                  style={{ maxWidth: 120, fontSize: "12px" }}
                />
              </div>

              <div style={{ minWidth: 90 }}>
                <div className="small text-muted">In Stock</div>
                <div style={{ fontWeight: 600 }}>{row.in_stock ?? 0}</div>
              </div>

              <div style={{ minWidth: 90 }}>
                <div className="small text-muted">Total</div>
                <div style={{ fontWeight: 600 }}>
                  {Number(row.total ?? 0).toFixed(2)}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="small text-muted">Net Price</div>
                <div style={{ fontWeight: 700 }}>
                  {Number(row.net_price ?? 0).toFixed(2)}
                </div>
              </div>

              <div className="d-flex gap-1">
                <button
                  type="button"
                  className="btn btn-icon btn-sm btn-soft-danger"
                  onClick={() => deleteProduct(index)}
                  disabled={productRows.length === 1}
                  title="Delete"
                >
                  <i className="feather-trash" />
                </button>
              </div>
            </div>

            {formError.product_list?.[index] && (
              <div className="mt-2 text-danger small">
                {Object.values(formError.product_list[index]).join(" • ")}
              </div>
            )}
          </div>
        </div>
      );
    });

  /* ---------- Auth check ---------- */
  if (!isAuthenticated()) return <Navigate to="/login" replace />;

  /* ---------- Render ---------- */
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row page-header">
          <div className="col-12">
            <div className="d-flex align-items-start justify-content-between">
              <div className="d-flex align-items-center gap-2">
                <h4 className="page-title mb-0">
                  Orders
                  <span className="count-title">{totalItems}</span>
                </h4>
              </div>

              <div className="col-12 col-md-4">
                <div className="card-control position-relative">
                  <div className="icon-form">
                    <Search
                      placeholder="Enter Text ..."
                      value={query}
                      onChange={setQuery}
                      searchText={searchTextData}
                      loading={loadingSearch}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center gap-2">
                <div className="d-flex justify-content-end gap-2"></div>
              </div>
              {/* <div className="d-flex align-items-center gap-2">
                <div className="d-flex justify-content-end gap-2">
                  <Export
                    options={[
                      {
                        label: downloading
                          ? "Downloading..."
                          : exporting
                          ? "Generating..."
                          : "Export",
                        iconClass: downloading
                          ? "ti ti-download"
                          : exporting
                          ? "ti ti-loader"
                          : "ti ti-file-type-xls",
                        colorClass:
                          exporting || downloading
                            ? "text-muted"
                            : "text-primary",
                        onClick:
                          exporting || downloading ? undefined : exportFile,
                      },
                    ]}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div className="card mb-2">
          <div className="card-body">
            <div className="row g-2 align-items-center">
              {/* <div className="col-12 col-md-2">
                <div className="icon-form">
                  <span className="form-icon">
                    <i className="ti ti-search" />
                  </span>
                  <Search
                    placeholder="Search ..."
                    value={query}
                    onChange={(v) => {
                      setQuery(v);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div> */}
              <div className="col-12 col-md-3">
                <div className="card-control position-relative">
                  <div className="icon-form">
                    <span className="form-icon">
                      <i className="ti ti-calendar" />
                    </span>
                    <DateRangePicker
                      initialSettings={{
                        autoUpdateInput: false,
                        locale: { cancelLabel: "Clear" },
                      }}
                      onCallback={(start, end) => {
                        setStartDate(start.format("YYYY-MM-DD"));
                        setEndDate(end.format("YYYY-MM-DD"));
                      }}
                      onCancel={() => {
                        setStartDate("");
                        setEndDate("");
                      }}
                    >
                      <input
                        type="text"
                        className="form-control bookingrange"
                        placeholder="Select Date Range Filter"
                        value={
                          startDate && endDate
                            ? `${dayjs(startDate).format(
                                "DD-MM-YYYY",
                              )} - ${dayjs(endDate).format("DD-MM-YYYY")}`
                            : ""
                        }
                        readOnly
                        style={{ cursor: "pointer" }}
                        aria-label="Select date range"
                      />
                    </DateRangePicker>
                  </div>
                </div>
              </div>

              {/* <div className="col-12 col-md-3">
                <FilterDropdown
                  label="Owner"
                  endpoint="/getOwnerDD"
                  selected={ownerFilter}
                  onChange={(v) => setOwnerFilter(v as number[])}
                />
              </div> */}

              <div className="col-12 col-md-3">
                <FilterDropdown
                  label="Principal"
                  endpoint="/getPrincipalDD"
                  selected={principalFilter}
                  onChange={(v) => setPrincipalFilter(v as number[])}
                />
              </div>

              <div className="col-12 col-md-2">
                <FilterDropdown
                  label="Branch"
                  endpoint="/getBranchDD"
                  selected={branchFilter}
                  onChange={(v) => setBranchFilter(v as number[])}
                />
              </div>

              <div className="col-12 col-md-2">
                <FilterDropdown
                  label="Currency"
                  endpoint="/getCurrencyDD"
                  selected={currencyFilter}
                  onChange={(v) => setCurrencyFilter(v as number[])}
                />
              </div>

              <div className="col-12 col-md-2">
                <FilterDropdown
                  label="Status"
                  endpoint="/getOrderStatusDD"
                  selected={statusFilter}
                  onChange={(v) => setStatusFilter(v as number[])}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              {loading ? <Loader /> : <Table data={list} columns={columns} />}
            </div>
          </div>

          <Pagination
            currentPage={currentPage}
            perPage={perPage}
            totalItems={totalItems}
            onPageChange={(p) => setCurrentPage(p)}
            onPerPageChange={(pp) => {
              setPerPage(pp);
              setCurrentPage(1);
            }}
            perPageOptions={[
              { value: 5, label: "5" },
              { value: 10, label: "10" },
              { value: 25, label: "25" },
            ]}
          />
        </div>

        {/* Offcanvas Form */}
        <div
          className={`offcanvas offcanvas-end offcanvas-large ${
            showForm ? "show" : ""
          }`}
          tabIndex={-1}
          role="dialog"
        >
          <div className="offcanvas-header border-bottom offcanvas-large-custom">
            <h5 className="fw-semibold">
              {closeOrderTitle
                ? "Close Order"
                : orderTitle
                  ? "Prepare Partial Order"
                  : "Order"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                setShowForm(false);
                setOrderTitle(false);
                setCloseOrderTitle(false);
              }}
            />
          </div>

          <div className="offcanvas-body">
            {/* form — left col */}
            <div className="row">
              <div className="col-12 col-md-4 form-col">
                <div className="mb-1">
                  <label className="col-form-label">
                    Lead From <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled
                    type="text"
                    placeholder={"Lead From"}
                    name="lead_from"
                    className="form-control"
                    value={formData.lead_from || ""}
                    onChange={(e) => setField("lead_from", e.target.value)}
                    style={{ background: "#F6F6F6" }}
                  />
                  {formError.lead_from && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.lead_from}
                    </div>
                  )}
                </div>

                <div className="mb-1">
                  <label className="col-form-label">
                    Select Company <span className="text-danger">*</span>
                  </label>
                  <Select
                    isDisabled
                    placeholder="Company"
                    name="company_id"
                    classNamePrefix="react-select"
                    className="tagging"
                    options={companyOptions}
                    value={selectedOption(companyOptions, formData.company_id)}
                    onChange={(s) => {
                      // still allow updating address if required
                      if (!s) return;
                      const selected = s as any;
                      const updates: any = {
                        billing_address: selected.address || null,
                        billing_city: selected.city || null,
                        billing_state_id: selected.state_id || "",
                        billing_mobile: selected.mobile_no || "",
                        billing_email: selected.email_id || "",
                        billing_landline: selected.landline_no || "",
                        billing_pin_code: selected.pin_code || "",
                        contact_person: selected.customer_name || "",
                        shipping_address: selected.address || null,
                        shipping_city: selected.city || null,
                        shipping_state_id: selected.state_id || "",
                      };
                      setFormData((prev: any) => ({
                        ...prev,
                        ...updates,
                        company_id: selected.value,
                      }));
                      setAddressInfo(selected || {});
                    }}
                    isClearable
                  />
                  {formError.company_id && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.company_id}
                    </div>
                  )}
                </div>

                <div className="mb-1">
                  <label className="col-form-label">
                    Quotation Type <span className="text-danger">*</span>
                  </label>
                  <Select
                    isDisabled
                    placeholder="Type"
                    name="quotation_type_id"
                    classNamePrefix="react-select"
                    className="tagging"
                    options={quotationTypeOptions}
                    value={selectedOption(
                      quotationTypeOptions,
                      formData.quotation_type_id,
                    )}
                    onChange={(s) =>
                      setField("quotation_type_id", s?.value ?? null)
                    }
                    isClearable
                  />
                  {formError.quotation_type_id && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.quotation_type_id}
                    </div>
                  )}
                </div>
                {/* 
                <div className="mb-1">
                  <label className="col-form-label">
                    Notification Group
                  </label>
                  <Select
                    isDisabled
                    placeholder="Group"
                    name="notification_id"
                    classNamePrefix="react-select"
                    className="tagging"
                    options={notificationOptions}
                    value={selectedOption(
                      notificationOptions,
                      formData.notification_id
                    )}
                    onChange={(s) =>
                      setField("notification_id", s?.value ?? null)
                    }
                    isClearable
                  />
                  {formError.notification_id && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.notification_id}
                    </div>
                  )}
                </div> */}
                <div className="mb-1">
                  <label className="col-form-label">Owner</label>
                  <Select
                    isDisabled
                    placeholder="Owner"
                    name="owner_id"
                    classNamePrefix="react-select"
                    className="tagging"
                    options={ownerOptions}
                    value={selectedOption(ownerOptions, formData.owner_id)}
                    onChange={(s) => setField("owner_id", s?.value ?? null)}
                    isClearable
                  />
                  {formError.owner_id && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.owner_id}
                    </div>
                  )}
                </div>

                <div className="mb-1">
                  <label className="col-form-label">
                    Date <span className="text-danger">*</span>
                  </label>
                  <DatePicker
                    value={
                      formData.date
                        ? dayjs(formData.date, "YYYY-MM-DD")
                        : dayjs()
                    }
                    format="DD-MM-YYYY"
                    disabledDate={disabledDate}
                    onChange={(date) =>
                      setField("date", date ? date.format("YYYY-MM-DD") : "")
                    }
                    className="form-control"
                    style={{ width: "100%" }}
                  />
                  {formError?.date && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError?.date}
                    </div>
                  )}
                </div>

                <div className="mb-1">
                  <label className="col-form-label">
                    Enq Reference <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled
                    type="text"
                    name="enq_ref"
                    className="form-control"
                    placeholder="Enq Ref"
                    value={formData.enq_ref || ""}
                    onChange={(e) => setField("enq_ref", e.target.value)}
                    style={{ background: "#F6F6F6" }}
                  />
                  {formError.enq_ref && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.enq_ref}
                    </div>
                  )}
                </div>

                <div className="mb-1">
                  <label className="col-form-label">
                    Prepard By <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    type="text"
                    name="prepard_by"
                    className="form-control"
                    placeholder="Prepare By"
                    value={formData.prepard_by || ""}
                    onChange={(e) => setField("prepard_by", e.target.value)}
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.prepard_by && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.prepard_by}
                    </div>
                  )}
                </div>

                <div className="mb-1">
                  <label className="col-form-label">
                    Contact person <span className="text-danger">*</span>
                  </label>
                  <input
                    readOnly
                    type="text"
                    name="contact_person"
                    className="form-control"
                    placeholder="Contact Person"
                    value={formData.contact_person || ""}
                    style={{ background: "#F6F6F6" }}
                  />
                </div>

                <div className="mb-1">
                  <label className="col-form-label">Select Currency</label>
                  <Select
                    isDisabled
                    placeholder="Currency"
                    name="currency_id"
                    classNamePrefix="react-select"
                    className="tagging"
                    options={currencyOptions}
                    value={selectedOption(
                      currencyOptions,
                      formData.currency_id,
                    )}
                    onChange={(s) => setField("currency_id", s?.value ?? null)}
                    isClearable
                  />
                  {formError.currency_id && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.currency_id}
                    </div>
                  )}
                </div>
              </div>

              {/* mid col */}
              <div className="col-12 col-md-4 form-col">
                <div className="mb-1">
                  <label className="col-form-label">Order No.</label>
                  <input
                    readOnly
                    placeholder={"Order No"}
                    name="unique_order_no"
                    type="text"
                    className="form-control"
                    value={formData.unique_order_no || ""}
                    onChange={(e) =>
                      setField("unique_order_no", e.target.value)
                    }
                    style={{ background: "#F6F6F6" }}
                  />
                  {formError.unique_order_no && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.unique_order_no}
                    </div>
                  )}
                </div>

                <div className="mb-1" ref={setRef("billing_address")}>
                  <label className="col-form-label">
                    Billing Address <span className="text-danger">*</span>
                  </label>
                  <textarea
                    disabled={closeOrderTitle}
                    placeholder={"Billing"}
                    name="billing_address"
                    className="form-control"
                    value={formData.billing_address || ""}
                    onChange={(e) =>
                      setField("billing_address", e.target.value)
                    }
                    style={{
                      height: "100px",
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.billing_address && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.billing_address}
                    </div>
                  )}
                </div>

                {addressInfo?.other_state ? (
                  <div className="mb-1" ref={setRef("billing_other_state")}>
                    <label className="col-form-label">
                      Other State <span className="text-danger">*</span>
                    </label>
                    <input
                      disabled={closeOrderTitle}
                      placeholder={"State"}
                      name="billing_other_state"
                      type="text"
                      className="form-control"
                      value={formData.billing_other_state || ""}
                      onChange={(e) =>
                        setField("billing_other_state", e.target.value)
                      }
                      style={{
                        background: closeOrderTitle ? "#F6F6F6" : "none",
                      }}
                    />
                  </div>
                ) : (
                  <div className="mb-1" ref={setRef("billing_state_id")}>
                    <label className="col-form-label">
                      State <span className="text-danger">*</span>
                    </label>
                    <Select
                      isDisabled={closeOrderTitle}
                      name="billing_state_id"
                      classNamePrefix="react-select"
                      className="tagging"
                      options={stateOptions}
                      value={selectedOption(
                        stateOptions,
                        formData.billing_state_id,
                      )}
                      onChange={(s) =>
                        setField("billing_state_id", s?.value ?? null)
                      }
                      isClearable
                    />
                    {formError.billing_state_id && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.billing_state_id}
                      </div>
                    )}
                  </div>
                )}

                <div className="mb-1" ref={setRef("billing_city")}>
                  <label className="col-form-label">
                    City <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"City"}
                    name="billing_city"
                    type="text"
                    className="form-control"
                    value={formData.billing_city || ""}
                    onChange={(e) => setField("billing_city", e.target.value)}
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.billing_city && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.billing_city}
                    </div>
                  )}
                </div>

                <div className="mb-1" ref={setRef("billing_pin_code")}>
                  <label className="col-form-label">
                    Pin Code <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"Pin Code"}
                    name="billing_pin_code"
                    type="text"
                    className="form-control"
                    value={formData.billing_pin_code || ""}
                    onChange={(e) =>
                      setField("billing_pin_code", e.target.value)
                    }
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.billing_pin_code && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.billing_pin_code}
                    </div>
                  )}
                </div>

                <div className="mb-1" ref={setRef("billing_mobile")}>
                  <label className="col-form-label">
                    Mobile <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"Mobile"}
                    name="billing_mobile"
                    type="text"
                    className="form-control"
                    value={formData.billing_mobile || ""}
                    onChange={(e) => setField("billing_mobile", e.target.value)}
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.billing_mobile && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.billing_mobile}
                    </div>
                  )}
                </div>

                <div className="mb-1" ref={setRef("billing_email")}>
                  <label className="col-form-label">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"Email"}
                    name="billing_email"
                    type="text"
                    className="form-control"
                    value={formData.billing_email || ""}
                    onChange={(e) => setField("billing_email", e.target.value)}
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.billing_email && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.billing_email}
                    </div>
                  )}
                </div>

                <div className="mb-1" ref={setRef("billing_landline")}>
                  <label className="col-form-label">
                    Landline <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"Landline"}
                    name="billing_landline"
                    type="text"
                    className="form-control"
                    value={formData.billing_landline || ""}
                    onChange={(e) =>
                      setField("billing_landline", e.target.value)
                    }
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.billing_landline && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.billing_landline}
                    </div>
                  )}
                </div>
              </div>

              {/* right col */}
              <div className="col-12 col-md-4 form-col">
                <div className="mb-1">
                  <label className="col-form-label">Quotation No.</label>
                  <input
                    readOnly
                    placeholder={"unique_quotation_no"}
                    name="unique_quotation_no"
                    type="text"
                    className="form-control"
                    value={formData.unique_quotation_no || ""}
                    onChange={(e) =>
                      setField("unique_quotation_no", e.target.value)
                    }
                    style={{ background: "#F6F6F6" }}
                  />
                </div>

                <div className="mb-1" ref={setRef("shipping_address")}>
                  <label className="col-form-label">
                    Shipping Address <span className="text-danger">*</span>
                  </label>
                  <textarea
                    disabled={closeOrderTitle}
                    placeholder={"Shipping"}
                    name="shipping_address"
                    className="form-control"
                    value={formData.shipping_address || ""}
                    onChange={(e) =>
                      setField("shipping_address", e.target.value)
                    }
                    style={{
                      height: "100px",
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.shipping_address && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.shipping_address}
                    </div>
                  )}
                </div>

                {addressInfo?.other_state ? (
                  <div className="mb-1" ref={setRef("shipping_other_state")}>
                    <label className="col-form-label">
                      Other State <span className="text-danger">*</span>
                    </label>
                    <input
                      disabled={closeOrderTitle}
                      placeholder={"State"}
                      name="shipping_other_state"
                      type="text"
                      className="form-control"
                      value={formData.shipping_other_state || ""}
                      onChange={(e) =>
                        setField("shipping_other_state", e.target.value)
                      }
                      style={{
                        background: closeOrderTitle ? "#F6F6F6" : "none",
                      }}
                    />
                    {formError.shipping_other_state && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.shipping_other_state}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="mb-1" ref={setRef("shipping_state_id")}>
                    <label className="col-form-label">
                      State <span className="text-danger">*</span>
                    </label>
                    <Select
                      isDisabled={closeOrderTitle}
                      name="shipping_state_id"
                      classNamePrefix="react-select"
                      className="tagging"
                      options={stateOptions}
                      value={selectedOption(
                        stateOptions,
                        formData.shipping_state_id,
                      )}
                      onChange={(s) =>
                        setField("shipping_state_id", s?.value ?? null)
                      }
                      isClearable
                    />
                    {formError.shipping_state_id && (
                      <div className="invalid-feedback d-block text-danger">
                        {formError.shipping_state_id}
                      </div>
                    )}
                  </div>
                )}

                <div className="mb-1" ref={setRef("shipping_city")}>
                  <label className="col-form-label">
                    City <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"City"}
                    name="shipping_city"
                    type="text"
                    className="form-control"
                    value={formData.shipping_city || ""}
                    onChange={(e) => setField("shipping_city", e.target.value)}
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.shipping_city && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.shipping_city}
                    </div>
                  )}
                </div>

                <div className="mb-1" ref={setRef("shipping_pin_code")}>
                  <label className="col-form-label">
                    Pin Code <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"Pin Code"}
                    name="shipping_pin_code"
                    type="text"
                    className="form-control"
                    value={formData.shipping_pin_code || ""}
                    onChange={(e) =>
                      setField("shipping_pin_code", e.target.value)
                    }
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.shipping_pin_code && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.shipping_pin_code}
                    </div>
                  )}
                </div>

                <div className="mb-1" ref={setRef("shipping_mobile")}>
                  <label className="col-form-label">
                    Mobile <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"Mobile"}
                    name="shipping_mobile"
                    type="text"
                    className="form-control"
                    value={formData.shipping_mobile || ""}
                    onChange={(e) =>
                      setField("shipping_mobile", e.target.value)
                    }
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.shipping_mobile && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.shipping_mobile}
                    </div>
                  )}
                </div>

                <div className="mb-1" ref={setRef("shipping_email")}>
                  <label className="col-form-label">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"Email"}
                    name="shipping_email"
                    type="text"
                    className="form-control"
                    value={formData.shipping_email || ""}
                    onChange={(e) => setField("shipping_email", e.target.value)}
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.shipping_email && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.shipping_email}
                    </div>
                  )}
                </div>

                <div className="mb-1" ref={setRef("shipping_landline")}>
                  <label className="col-form-label">
                    Landline <span className="text-danger">*</span>
                  </label>
                  <input
                    disabled={closeOrderTitle}
                    placeholder={"Landline"}
                    name="shipping_landline"
                    type="text"
                    className="form-control"
                    value={formData.shipping_landline || ""}
                    onChange={(e) =>
                      setField("shipping_landline", e.target.value)
                    }
                    style={{
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                  {formError.shipping_landline && (
                    <div className="invalid-feedback d-block text-danger">
                      {formError.shipping_landline}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mb-1" ref={setRef("courier_id")}>
              <div className="col-md-4 mb-1">
                <label className="col-form-label">
                  Select Courier <span className="text-danger">*</span>
                </label>
                <Select
                  isDisabled={closeOrderTitle}
                  placeholder="Select Preferred Courier"
                  name="courier_id"
                  classNamePrefix="react-select"
                  className="tagging"
                  options={courierOptions}
                  value={selectedOption(courierOptions, formData.courier_id)}
                  onChange={(s) => setField("courier_id", s?.value ?? null)}
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      backgroundColor: closeOrderTitle ? "#F6F6F6" : "",
                    }),
                  }}
                />
                {formError.courier_id && (
                  <div className="invalid-feedback d-block text-danger">
                    {formError.courier_id}
                  </div>
                )}
              </div>

              <div className="col-md-4  mb-1" ref={setRef("delivery_date_id")}>
                <label className="col-form-label">
                  Payment Terms <span className="text-danger">*</span>
                </label>
                <Select
                  isDisabled={closeOrderTitle}
                  placeholder="Deliver"
                  name="delivery_date_id"
                  classNamePrefix="react-select"
                  className="tagging"
                  options={paymentAdvanceOptions}
                  value={selectedOption(
                    paymentAdvanceOptions,
                    formData.delivery_date_id,
                  )}
                  onChange={(s) =>
                    setField("delivery_date_id", s?.value ?? null)
                  }
                  isClearable
                />
                {formError.delivery_date_id && (
                  <div className="invalid-feedback d-block text-danger">
                    {formError.delivery_date_id}
                  </div>
                )}
              </div>

              <div className="col-md-4  mb-1" ref={setRef("customer_order_no")}>
                <label className="col-form-label">
                  Customer Order No. <span className="text-danger">*</span>
                </label>
                <input
                  disabled={closeOrderTitle}
                  placeholder={"Customer Order No"}
                  name="customer_order_no"
                  type="text"
                  className="form-control"
                  value={formData.customer_order_no || ""}
                  onChange={(e) =>
                    setField("customer_order_no", e.target.value)
                  }
                  style={{
                    background: closeOrderTitle ? "#F6F6F6" : "none",
                  }}
                />
                {formError.customer_order_no && (
                  <div className="invalid-feedback d-block text-danger">
                    {formError.customer_order_no}
                  </div>
                )}
              </div>
            </div>

            {/* product table */}
            <div
              style={{
                borderRadius: "14px",
                overflow: "auto",
              }}
            >
              <table
                className="table table-view"
                style={{
                  tableLayout: "auto",
                  fontSize: "12px",
                  borderCollapse: "separate",
                  borderSpacing: 0,
                }}
              >
                {/* ================= HEADER ================= */}
                <thead>
                  <tr>
                    <th
                      style={{
                        top: 0,
                        zIndex: 1,
                        fontSize: "11px",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        textAlign: "center",
                        borderBottom: "1px solid #e5e7eb",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Select [✓]
                    </th>
                    {[
                      "Part No.",
                      "Description",
                      ...(quotationType == "GW"
                        ? ["Principal", "UOM", "Specification & Heading"]
                        : []),
                      "HSN",
                      "Qty",
                      "Send Qty",
                      "In Stock",
                      `Price [${currencyName}]`,
                      "Disc %",
                      "Net Price",
                      "IGST %",
                      "Total",
                      "Notes",
                      // "Action",
                    ].map((h, i) => (
                      <th
                        key={i}
                        style={{
                          top: 0,
                          zIndex: 1,
                          fontSize: "11px",
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: ".04em",
                          textAlign: "center",
                          padding: "10px 8px",
                          borderBottom: "1px solid #e5e7eb",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {!(closeOrderTitle && h === "Action") && h}
                      </th>
                    ))}
                  </tr>
                </thead>

                {/* ================= BODY ================= */}
                <tbody>
                  {productRows.length === 0 ? (
                    <tr>
                      <td
                        colSpan={15}
                        style={{ padding: "24px", textAlign: "center" }}
                      >
                        <b>Note:</b> No products added. Use search to add
                        products.
                        {formError.product_list && (
                          <div className="text-danger mt-2">
                            At least one product is required
                          </div>
                        )}
                      </td>
                    </tr>
                  ) : (
                    productRows.map((row, index) => (
                      <React.Fragment key={index}>
                        <tr key={index}>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                              borderBottom: "1px solid #f1f5f9",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={
                                row.is_checked == undefined ||
                                row.is_checked == null
                                  ? true
                                  : row.is_checked
                              }
                              disabled={closeOrderTitle}
                              onChange={(e) => {
                                const checked = e.target.checked;

                                setProductRows((prev) => {
                                  const updated = [...prev];
                                  updated[index].is_checked = checked;

                                  return updated;
                                });
                              }}
                            />
                          </td>
                          {(
                            [
                              "part_no",
                              "description",
                              ...(quotationType == "GW"
                                ? ["principal", "uom", "specification"]
                                : []),
                              "hsn_code",
                              "quantity",
                              "send_qty",
                              "in_stock",
                              "price",
                              "discount",
                              "net_price",
                              "igst",
                              "total",
                              "notes",
                            ] as const
                          ).map((field) => {
                            const widths: Record<string, string> = {
                              part_no: "240px",
                              description: "20px",
                              principal: "150px",
                              uom: "70px",
                              specification: "20px",
                              hsn_code: "120px",
                              quantity: "90px",
                              send_qty: "20px",
                              in_stock: "20px",
                              price: "100px",
                              discount: "40px",
                              net_price: "100px",
                              igst: "50px",
                              total: "100px",
                              notes: "30px",
                            };

                            return (
                              <>
                                <td
                                  key={field}
                                  style={{
                                    minWidth: widths[field],
                                    maxWidth: widths[field],
                                    padding: "2px",
                                    verticalAlign: "middle",
                                    borderBottom: "1px solid #f1f5f9",
                                  }}
                                >
                                  {[
                                    "description",
                                    "specification",
                                    "notes",
                                    "product_description",
                                  ].includes(field) ? (
                                    <button
                                      className="btn btn-sm-outline w-100"
                                      style={{
                                        borderRadius: "8px",
                                        border: "1px dashed #cbd5e1",
                                        background: "#f8fafc",
                                      }}
                                      disabled={
                                        formData?.pending_quotation_details
                                          ?.status_code === "win"
                                      }
                                      onClick={() =>
                                        openEditor(index, field as any)
                                      }
                                    >
                                      {row[field] != "" &&
                                      row[field] != undefined ? (
                                        <>
                                          <i className="ti ti-pencil" />
                                        </>
                                      ) : (
                                        <>
                                          <i className="ti ti-plus" />
                                        </>
                                      )}
                                    </button>
                                  ) : field === "quantity" ? (
                                    <div className="input-group input-group-sm">
                                      <button
                                        className="btn btn-outline-success"
                                        disabled={true}
                                        onClick={() =>
                                          updateRow(
                                            index,
                                            field,
                                            numberOrZero(row[field]) - 1,
                                          )
                                        }
                                      >
                                        −
                                      </button>

                                      <input
                                        disabled={true}
                                        className="form-control text-center"
                                        value={row[field] ?? 0}
                                        onChange={(e) =>
                                          updateRow(
                                            index,
                                            field,
                                            numberOrZero(e.target.value),
                                          )
                                        }
                                        style={{
                                          fontSize: "12px",
                                          background: ["quantity"].includes(
                                            field,
                                          )
                                            ? "#f8fafc"
                                            : "#ffffff",
                                          borderRadius: "8px",
                                        }}
                                      />
                                      <button
                                        disabled={true}
                                        className="btn btn-outline-success"
                                        onClick={() =>
                                          updateRow(
                                            index,
                                            field,
                                            numberOrZero(row[field]) + 1,
                                          )
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  ) : (
                                    <input
                                      type={
                                        field === "send_qty" ? "number" : "text"
                                      }
                                      className="form-control form-control-md"
                                      min={field === "send_qty" ? 0 : undefined}
                                      placeholder={
                                        field === "send_qty" ? "0" : undefined
                                      }
                                      readOnly={
                                        [
                                          "part_no",
                                          "net_price",
                                          "in_stock",
                                          "total",
                                          "uom",
                                          "hsn_code",
                                          "price",
                                          "discount",
                                          "igst",
                                        ].includes(field) || closeOrderTitle
                                      }
                                      value={
                                        field === "send_qty"
                                          ? closeOrderTitle
                                            ? row["quantity"]
                                            : (row[field] ?? "0")
                                          : field === "principal"
                                            ? typeof row[field] === "object"
                                              ? (row[field]?.type ?? "")
                                              : (row[field] ?? "")
                                            : field === "uom"
                                              ? typeof row[field] === "object"
                                                ? (row[field]?.uom ?? "")
                                                : (row[field] ?? "")
                                              : (row[field] ?? "")
                                      }
                                      onChange={(e) =>
                                        updateRow(index, field, e.target.value)
                                      }
                                      style={{
                                        fontSize: "12px",
                                        background:
                                          [
                                            "net_price",
                                            "total",
                                            "part_no",
                                            "in_stock",
                                            "uom",
                                            "hsn_code",
                                            "price",
                                            "discount",
                                            "igst",
                                          ].includes(field) || closeOrderTitle
                                            ? "#f8fafc"
                                            : "#ffffff",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  )}
                                </td>
                              </>
                            );
                          })}

                          {/* {!closeOrderTitle && (
                            <td
                              className="d-flex gap-1"
                              style={{ justifyContent: "center" }}
                            >
                              <button
                                disabled={
                                  formData?.pending_quotation_details
                                    ?.status_code == "win"
                                }
                                type="button"
                                className="btn btn-icon btn-sm btn-soft-secondary"
                                onClick={() =>
                                  openEditor(index, "Comments" as any)
                                }
                                title="Add Comments"
                              >
                                <i className="fa fa-comment" />
                              </button>
                              <button
                                className="btn btn-icon btn-sm btn-soft-danger"
                                disabled={
                                  productRows.length === 1 ||
                                  formData?.pending_quotation_details
                                    ?.status_code === "win"
                                }
                                onClick={() => deleteProduct(index)}
                              >
                                <i className="feather-trash" />
                              </button>
                            </td>
                          )} */}
                        </tr>
                        {/* {row.showDescriptionEditor && (
                            <tr>
                              <td colSpan={13}>
                                <QuillEditor
                                  value={row.product_specification}
                                  onChange={(html: any) => {
                                    setProductRows((prev) => {
                                      const updated = [...prev];
                                      updated[index].product_specification =
                                        html;
                                      return updated;
                                    });
                                  }}
                                  placeholder="Write Comment ..."
                                  height={70}
                                />
                                {formError.product_list?.[index]
                                  ?.product_specification && (
                                  <div className="invalid-feedback d-block text-danger">
                                    {
                                      formError.product_list[index]
                                        .product_specification
                                    }
                                  </div>
                                )}
                              </td>
                            </tr>
                          )} */}
                      </React.Fragment>
                    ))
                  )}
                </tbody>

                {/* ================= FOOTER ================= */}
                {!isMobile && productRows.length > 0 && (
                  <tfoot>
                    <tr>
                      <td colSpan={8}></td>
                      <td
                        colSpan={quotationType == "GW" ? 5 : 1}
                        style={{
                          textAlign: "right",
                          fontWeight: 600,
                          padding: "12px",
                          borderTop: "2px solid #e5e7eb",
                        }}
                      >
                        Sub Total
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          fontWeight: 700,
                        }}
                      >
                        {subTotal.toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
            {/* notes + courier */}
            <div className="row" style={{ marginTop: "-15px" }}>
              <div className="col-12 form-col">
                <div className="mb-1">
                  <label className="col-form-label">Extra Notes</label>
                  <textarea
                    disabled={closeOrderTitle}
                    placeholder={"Extra note , if any !"}
                    name="extra_notes"
                    className="form-control"
                    value={formData.extra_notes || ""}
                    onChange={(e) => setField("extra_notes", e.target.value)}
                    style={{
                      height: "100px",
                      background: closeOrderTitle ? "#F6F6F6" : "none",
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              className="d-flex justify-content-end"
              style={{ marginTop: "10px" }}
            >
              <button
                type="button"
                className={
                  closeOrderTitle
                    ? "btn btn-soft-warning  me-2"
                    : "btn btn-soft-primary  me-2"
                }
                onClick={() => {
                  setShowForm(false);
                  resetForm();
                  setCloseOrderTitle(false);
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className={
                  closeOrderTitle
                    ? "btn btn-soft-primary  me-2"
                    : "btn btn-soft-success  me-2"
                }
                disabled={submitting}
                type="button"
              >
                {submitting ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    />
                    {orderTitle && selectedId
                      ? "Generating Partial Order..."
                      : selectedId
                        ? "Updating..."
                        : "Creating..."}
                  </>
                ) : closeOrderTitle ? (
                  "Close Order"
                ) : orderTitle && selectedId ? (
                  "Generate Partial Order"
                ) : selectedId ? (
                  "Update"
                ) : (
                  "Create"
                )}
              </button>
            </div>
          </div>
        </div>

        {editor && (
          <div
            className="modal fade show d-block"
            style={{ background: "rgba(0,0,0,.4)" }}
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {editor.field === "product_specification"
                      ? "COMMENTS"
                      : editor.field.replace("_", " ").toUpperCase()}{" "}
                    {`( ROW => ${editor.index + 1} )`}
                  </h5>
                  <button className="btn-close" onClick={closeEditor} />
                </div>

                <div className="modal-body">
                  {editor.field === "notes" ||
                  editor.field === "description" ? (
                    <textarea
                      disabled
                      className="form-control"
                      rows={8}
                      value={editorValue}
                      onChange={(e) => setEditorValue(e.target.value)}
                      style={{
                        background: "#F6F6F6",
                      }}
                    />
                  ) : (
                    <QuillEditor
                      value={editorValue}
                      onChange={(html: string) => setEditorValue(html)}
                      height={200}
                      placeholder="Write ..."
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Reason modal */}
        <Reason
          show={showMessageModal}
          id="messageModal"
          title="Order Status Update"
          onHide={() => setShowMessageModal(false)}
          pendingSubmitting={pendingSubmitting}
          footer={
            permissionMap?.order?.edit_order_reason &&
            !quotationReason?.pending_quotation_details && (
              <>
                <button
                  type="button"
                  className="btn btn-soft-danger"
                  disabled={pendingSubmitting}
                  onClick={() => setShowMessageModal(false)}
                >
                  Close
                </button>

                <button
                  type="button"
                  className="btn btn-soft-success"
                  onClick={updateReasonStatus}
                  disabled={pendingSubmitting}
                >
                  {pendingSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Sending...
                    </>
                  ) : (
                    "Send message"
                  )}
                </button>
              </>
            )
          }
        >
          <form>
            <div className="mb-2">
              <label className="form-label">Order No :</label>
              <input
                readOnly
                type="text"
                className="form-control"
                value={formDataPendingQuotation?.unique_order_no || ""}
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Order Date :</label>
              <input
                readOnly
                type="text"
                className="form-control"
                value={quotationReason?.created_at || ""}
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Order Value :</label>
              <input
                readOnly
                type="text"
                className="form-control"
                value={quotationReason?.total_amount || ""}
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Email Id :</label>
              <input
                readOnly
                type="text"
                className="form-control"
                value={quotationReason?.company_details?.email_id || ""}
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Select Reason :</label>
              <Select
                name="reason_status_id"
                placeholder="Select Status"
                options={statusOptions}
                value={selectedOption(
                  statusOptions,
                  Number(formDataPendingQuotation.reason_status_id) || null,
                )}
                onChange={(s: any) =>
                  setPendingField("reason_status_id", s?.value ?? "")
                }
                isClearable
                classNamePrefix="react-select"
              />
              {formErrorPendingQuotation.reason_status_id && (
                <div className="invalid-feedback d-block text-danger">
                  {formErrorPendingQuotation.reason_status_id}
                </div>
              )}
            </div>

            <div className="mb-2">
              <label className="form-label">Reason Description :</label>
              <textarea
                disabled={quotationReason?.pending_quotation_details}
                name="reason_text"
                className="form-control"
                placeholder={descReason || "No existing reason"}
                onChange={(e) => setPendingField("reason_text", e.target.value)}
                style={{ height: "150px" }}
              />
              {formErrorPendingQuotation.reason_text && (
                <div className="invalid-feedback d-block text-danger">
                  {formErrorPendingQuotation.reason_text}
                </div>
              )}
            </div>
          </form>
        </Reason>

        <Success
          id="formatSuccessModal"
          title={orderTitle ? "Order" : "Partial Order"}
          message={showMessage}
          show={showSuccess}
          onClose={() => setShowSuccess(false)}
        />

        <Delete
          show={showDeleteModal}
          title="Delete Order?"
          message="Are you sure?"
          onConfirm={confirmDelete}
          onCancel={() => {
            setShowDeleteModal(false);
            setOrderTitle(false);
          }}
        />
      </div>
    </div>
  );
};

export default Order;
